import React, {Component} from 'react'
import {Popup, Button} from 'semantic-ui-react'
import {buttonStyle} from '../button-style'
import {modal} from '../../contacts/modal'
import {saveNoteBulk} from '../../vpo-stages/save-note.js'
import $ from 'jquery'

class BulkEditVpoNotes extends Component {

  constructor(props) {
    super(props)
    this.state = {
      open: false,
      stage: '',
      filenames: []
    }
  }

  openModal = () => {
    let {numSelected} = this.props

    if (numSelected == 0) {
      alert('Select at least 1 VPO')
      return
    } else {
      this.setState({
        open: true,
        stage: ''
      })
    }
  }

  closeModal = () => {
    this.setState({open: false})
  }

  saveNote = () => {
    let {filenames, stage} = this.state
    if (stage == '') {
      alert('Select stage!')
      return
    }
    let text = $('#addContactNote').val().trim()
    if (text != '') {
      let filename = filenames.join('@@@')
      let {vpoIds} = window
      saveNoteBulk(vpoIds, text, stage, filename, (err, res) => {
        if (err) {
          alert('There was an error when trying to save note.')
        } else {
          alert('VPO note saved!')
          this.closeModal()
        }
      })
    }
  }

  addFilename = (filename) => {
    let {filenames} = this.state
    filenames.push(filename)
    this.setState({filenames})
  }

  removeFilename = (filename) => {
    let {filenames} = this.state
    filenames = filenames.filter(x => x != filename)
    this.setState({filenames})
  }

  stageOnChange = ({currentTarget}) => {
    let stage = currentTarget.value
    this.setState({stage})
  }

  render() {
    let {open, filenames, stage} = this.state

    return (
      <React.Fragment>
        {modal(open, this.closeModal, this.saveNote, filenames, this.addFilename, this.removeFilename, stage, this.stageOnChange)}
        <Popup content='Notes' position='bottom left'
          trigger={
            <Button basic icon='sticky note outline' onClick={this.openModal} style={buttonStyle}/>
          }
        />
      </React.Fragment>
    )
  }
}

export default BulkEditVpoNotes
